import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  card: {
    marginTop: 40,
  },
  checkbox: {
    width: "20px",
    height: "20px",
  },
  title: {
    textAlign: "center",
  },
  button: {
    margin: "5px",
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const EditSite = () => {
  const { poolId } = useParams();
  const classes = useStyles();

  const [poolObj, setPoolObj] = useState({
    pool: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/Pools/" + poolId)
      .then((response) => response.json())
      .then((data) =>
        setPoolObj({
          pool: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {poolObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <EditForm pool={poolObj.pool} />
      )}
    </>
  );
};

const EditForm = ({ pool: pool }) => {
  const classes = useStyles();
  const history = useNavigate();

  const [poolData, setPoolData] = useState({
    id: pool.id,
    name: pool.name,
    description: pool.description,
    siteId: pool.siteId,
    ownerTechnology: pool.ownerTechnology,
    healthy: pool.healthy,
  });

  const [submitData, setSubmitData] = useState(poolData);

  const myChangeHandler = (value, name) => {
    if (value === "") value = null;
    setSubmitData({
      ...submitData,
      [name]: value,
    });
  };

  const [loading, setLoading] = useState(false);

  const getInventoryStatus = (pool) => {
    var total = 0;
    var available = 0;
    var inventoryStatus = 0;

    for (var x = 0; x < pool.ranges.length; x++) {
      total += pool.ranges[x].totalCount;
    }

    for (var x = 0; x < pool.ranges.length; x++) {
      available += pool.ranges[x].availableCount;
    }

    if (available > 0 && total > 0) {
      inventoryStatus = Math.round((available / total) * 100);
    }

    return (
      <>
        <div class="mb-3 row" style={{ margin: "5px" }}>
          <label for="inputPassword" class="col-sm-4 col-form-label">
            <h6>Inventory Status:</h6>
          </label>
          <div class="col-sm-8" style={{ paddingTop: "6px" }}>
            <h6 name="inventoryStatus">{inventoryStatus}%</h6>
          </div>
        </div>
      </>
    );
  };

  const submitHandler = (e) => {
    e.preventDefault();

    var stringArray = [];
    var errorMesssage = "Validation Error - ";
    if (submitData.name == "") stringArray.push("Name");
    if (submitData.description == "") stringArray.push("Description");

    if (submitData.name == "" || submitData.description == "") {
      stringArray.map((error, index) => {
        errorMesssage += index == 0 ? error : ", " + error;
      });
      sendAlert((errorMesssage += " Required"), "warning");
      return;
    }

    if (
      submitData.name === poolData.name &&
      submitData.description === poolData.description &&
      submitData.healthy === poolData.healthy
    ) {
      sendAlert(`No Changes Made`, "warning");
      return;
    }

    setLoading(true);
    var successfulResponse = false;

    fetchWithToken(`api/Pools/`, "PUT", submitData)
      .then((res) => {
        if (res.ok) successfulResponse = true;
        return res.json();
      })
      .then((data) => {
        sendAlert(data.returnMessage, successfulResponse ? "success" : "error");
        setLoading(false);
        if (successfulResponse) {
          setPoolData((prev) => ({
            ...prev,
            name: submitData.name,
            description: submitData.description,
            healthy: submitData.healthy,
          }));
        }
        console.log("Data Returned: ", data.returnObject);
      });
  };

  const handleCancel = () => {
    history.goBack();
  };

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });
  };

  const clearAlert = () => {
    setAlertMessage({
      message: "",
      varient: "",
      active: false,
    });
  };

  return (
    <>
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <Card className={classes.card}>
            {alertMessage.active && (
              <Alert
                severity={alertMessage.varient}
                onClose={() => clearAlert()}
              >
                {alertMessage.message}
              </Alert>
            )}
            <CardContent>
              <form onSubmit={submitHandler}>
                <Typography
                  sx={{ fontSize: 14 }}
                  style={{ margin: "20px", fontSize: "1.5em" }}
                  color="text.secondary"
                  gutterBottom
                >
                  Edit Pool: {pool.id}
                </Typography>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label for="name" class="col-sm-4 col-form-label">
                    <h6>Name:</h6>
                  </label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      name="name"
                      maxLength="30"
                      defaultValue={pool.name}
                      onChange={(e) => {
                        clearAlert();
                        myChangeHandler(e.target.value.trim(), "name");
                      }}
                    />
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label for="description" class="col-sm-4 col-form-label">
                    <h6>Description:</h6>
                  </label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      name="description"
                      maxLength="200"
                      defaultValue={pool.description}
                      onChange={(e) => {
                        clearAlert();
                        myChangeHandler(e.target.value, "description");
                      }}
                    />
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label class="col-sm-4 col-form-label">
                    <h6>Site:</h6>
                  </label>
                  <div class="col-sm-8" style={{ paddingTop: "6px" }}>
                    <h6>{pool.site.name}</h6>
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label class="col-sm-4">
                    <h6>Healthy:</h6>
                  </label>
                  <div class="col-sm-8">
                    <input
                      class="form-check-input"
                      className={classes.checkbox}
                      type="checkbox"
                      name="healthy"
                      onChange={(e) => {
                        clearAlert();
                        myChangeHandler(
                          e.target.checked ? "Y" : "N",
                          "healthy"
                        );
                      }}
                      defaultChecked={pool.healthy === "Y"}
                    />
                  </div>
                </div>

                <div class="mb-3 row" style={{ margin: "5px" }}>
                  <label class="col-sm-4 col-form-label">
                    <h6>Owner Technology:</h6>
                  </label>
                  <div class="col-sm-8" style={{ paddingTop: "6px" }}>
                    <h6>{pool.ownerTechnology}</h6>
                  </div>
                </div>

                <div>{getInventoryStatus(pool)}</div>

                {loading && (
                  <>
                    <div style={{ margin: "25px" }}>
                      <span style={{ display: "table", margin: "0 auto" }}>
                        Please Wait For Process to Finish
                      </span>
                      <LinearProgress />
                    </div>
                  </>
                )}

                <div class="mb-3 row" style={{ margin: "20px" }}>
                  <Button
                    type="submit"
                    variant="contained"
                    className={classes.button}
                    color="primary"
                  >
                    Update
                  </Button>
                  <Button
                    variant="contained"
                    className={classes.button}
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default EditSite;
